import { Container } from '@dma/ui';
import type { AboutContentDto } from '../application/dto/AboutContentDto';
import './Timeline.css';

export interface TimelineProps {
  events: AboutContentDto['timeline'];
}

export function Timeline({ events }: TimelineProps) {
  if (events.length === 0) {
    return null;
  }
  return (
    <section className="dma-timeline" aria-labelledby="dma-timeline-heading">
      <Container>
        <h2 id="dma-timeline-heading">تاریخچه‌ی شرکت</h2>
        <ol className="dma-timeline__list">
          {events.map((event) => (
            <li key={`${event.year}-${event.title}`} className="dma-timeline__item">
              <span className="dma-timeline__year">{event.year}</span>
              <div>
                <h3 className="dma-timeline__title">{event.title}</h3>
                <p className="dma-timeline__description">{event.description}</p>
              </div>
            </li>
          ))}
        </ol>
      </Container>
    </section>
  );
}
